import type { ProgressBarDesignTokens, ProgressBarTokenSections } from '@primeuix/themes/types/progressbar';

// Rebrand 2026 (DS): 8px pill track on grey.100
export const root: ProgressBarTokenSections.Root = {
    background: '{extend.surfacesubtle}',
    borderRadius: '{extend.borderRadius.rounded}',
    height: '8px'
};

export const value: ProgressBarTokenSections.Value = {
    background: '{primary.color}'
};

export const label: ProgressBarTokenSections.Label = {
    color: '{primary.contrastColor}',
    fontSize: '0.75rem',
    fontWeight: '600'
};

export default {
    root,
    value,
    label
} satisfies ProgressBarDesignTokens;
